import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { DashboardShell, SharedDashboardShell } from "@/routes";
import { PUBLIC_ROUTES } from "@/routes/url";
import { ALL_PUBLIC_ROUTES, DASHBOARD_ROUTES, SHARED_DASHBOARD_ROUTES, EXTERNAL_DEAL_ROUTES } from "@/routes/RouteConfig";
import DevDebugBar from "@/components/common/DevDebugBar";
import ErrorBoundary from "@/components/common/ErrorBoundary";

export default function App() {
  return (
    <AuthProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <Toaster position="bottom-right" toastOptions={{ className: "!rounded-none !border-0 !bg-foreground !text-background" }} />
          <DevDebugBar />
          <Routes>
            {ALL_PUBLIC_ROUTES.map(({ path, component }) => (
              <Route key={path} path={path} element={component} />
            ))}
            <Route element={<DashboardShell />}>
              {DASHBOARD_ROUTES.map(({ path, component }) => (
                <Route key={path} path={path} element={component} />
              ))}
            </Route>
            <Route element={<SharedDashboardShell />}>
              {SHARED_DASHBOARD_ROUTES.map(({ path, component }) => (
                <Route key={path} path={path} element={component} />
              ))}
            </Route>
            {EXTERNAL_DEAL_ROUTES.map(({ path, component }) => (
              <Route key={path} path={path} element={component} />
            ))}
            <Route path="*" element={<Navigate to={PUBLIC_ROUTES.LANDING} replace />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    </AuthProvider>
  );
}
